var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"agent-promo-banners",class:{ 'agent-promo-banners--results': _vm.isResultsPage }},_vm._l((_vm.banners),function(banner){return _c('img',{key:banner.id,staticClass:"agent-promo-banners__item",attrs:{"src":banner.imageUrl,"alt":banner.alt,"draggable":"false"}})}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }